import { ISecurityProfilePermissions } from 'types/graphql'

export const getAvailablePages = (permissions: ISecurityProfilePermissions) => {
  if (!permissions) return []

  const { home, planRegister, kpiRegister, actionRegister, reporting, settings, risksRegister, objectiveRegister } =
    permissions

  const pages: string[] = []

  if (home) pages.push('/home')
  if (risksRegister) pages.push('/forms')
  if (planRegister) pages.push('/plans')
  if (kpiRegister) pages.push('/kpis/all')
  if (actionRegister) pages.push('/actions/all')
  if (objectiveRegister) pages.push('/objectives/all')
  if (reporting) pages.push('/data-hub')
  if (settings) pages.push('/settings/users')

  return pages
}
